import { Container } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";

import { APIConfiguration } from "./developer-api/APIConfiguration";
import { APIConfigurationList } from "./developer-api/APIConfigurationList";
import { PageTitle } from "../../components/page-title/PageTitle";

export function Integrations() {
  const { t } = useTranslation();

  return (
    <Container layout="full-width">
      <PageTitle>{t("Integrations")}</PageTitle>
      <Routes>
        <Route path="" element={<APIConfigurationList />} />
        <Route path="/:apiConfigurationID/*" element={<APIConfiguration />} />
      </Routes>
    </Container>
  );
}
